<template>
  <el-dropdown>
    <el-avatar class="user-icon" :size="32" style="" icon="el-icon-user-solid" @click="handleClick"></el-avatar>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item divided>
        <el-dropdown>
          <span>{{ i18n.ctrl.Language }}</span>
          <el-dropdown-menu slot="dropdown" placement="">
            <el-dropdown-item v-for="item in langOptions" :key="item.value">
              <span @click="changeLanguage(item.value)">{{ item.name }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-dropdown-item>
      <el-dropdown-item divided>{{ i18n.ctrl.UserGuide }}</el-dropdown-item>
      <el-dropdown-item divided>{{ i18n.ctrl.ModifyPassword }}</el-dropdown-item>
      <el-dropdown-item divided>{{ i18n.ctrl.UserSetting }}</el-dropdown-item>
      <el-dropdown-item divided>
        <span @click="clickLogout">{{ i18n.ctrl.Logout }}</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapActions } from "vuex"
import { LANG_OPTIONS } from "@/utils/options"
export default {
  data() {
    return {
      langOptions: LANG_OPTIONS
    }
  },
  computed: {
    i18n() {
      return this.$t("index")
    }
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    changeLanguage(lang) {
      this.$i18n.locale = lang
    },
    clickLogout() {
      this.logout()
    }
  }
}
</script>

<style scoped>
.user-icon {
  cursor: pointer;
  background: var(--white);
  color: var(--blue-light);
}
</style>



// WEBPACK FOOTER //
// src/layout/desktop/UserMenu.vue